<template>
  <div>
    <TopBar :mode="mode" @toggle="$emit('toggle')">
      <div class="flex items-center gap-4 xl:hidden">
        <span class="text-[21px] font-semibold custom:text-lg">Reports</span>
        <button
          class="button primary-button small-button"
          @click="$router.push({ name: 'serp-keyword-spy' })"
        >
          <TextSearch :size="20" :stroke-width="1.75" />
          Find the Boosting Keywords
        </button>
      </div>
    </TopBar>
    <div class="p-4">
      <div class="hidden items-center justify-between gap-4 xl:flex mb-4">
        <span class="text-[21px] font-semibold custom:text-lg">Reports</span>
        <button
          class="button primary-button small-button"
          @click="$router.push({ name: 'serp-keyword-spy' })"
        >
          <TextSearch :size="20" :stroke-width="1.75" />
          Find the Boosting Keywords
        </button>
      </div>
      <div
        class="rounded-xl shadow-card"
        :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
      >
        <ReportsList
          :pageSize="reportPageSize"
          :isHideTopBar="isHideReportTopBar"
          :isWizard="isWizard"
          :mode="mode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "../components/TopBar.vue";
import ReportsList from "../components/ReportsList.vue";
import { TextSearch } from "lucide-vue-next";
export default {
  setup() {
    return {};
  },
  props: {
    mode: String,
  },
  data() {
    return {
      reportPageSize: 20,
      isHideReportTopBar: false,
      isWizard: false,
    };
  },
  components: {
    ReportsList,
    TopBar,
    TextSearch,
  },
};
</script>
